import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureUpdatesService {

  constructor(
    private authService: AuthService,
    private http: HttpClient
  ) { }

  getFeatureUpdatesFileUrls(versionId: string, updates: string[]): Promise<{ [id:string]: string }> {
    return this.http.post<any>(environment.endPoints.featureupdates, { action: 'generateurls', token: this.authService.currentUser.token, version: versionId, updates: updates }).toPromise();
  }

  deleteFeatureUpdatesFiles(versionId: string): Promise<{ [id:string]: string }> {
    return this.http.post<any>(environment.endPoints.featureupdates, { action: 'delete', token: this.authService.currentUser.token, version: versionId }).toPromise();
  }
}
